import { AfterViewInit, Component, computed, ElementRef, inject, Injector, OnInit, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonButtonRowWidget, CommonForm, CommonUrlField, CommonUrlFieldConfig, CommonUrlFieldWidget } from '@eforall/common';
import { DashboardDialogFramePart, DialogContext } from '@eforall/dashboard';
import { FuncService } from '../../../../../../../services';


@Component({
	selector: 'facilitator-schedule-link-editor-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		CommonButtonRowWidget,
		CommonUrlFieldWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './facilitator-schedule-link-editor.dialog.html'
})

export class FacilitatorScheduleLinkEditorDialog implements OnInit, AfterViewInit {

	public dialogRef = inject(MatDialogRef<FacilitatorScheduleLinkEditorDialog>);
	public dialogContext: DialogContext<{ accId: number, scheduleLink: string | undefined }> = inject(MAT_DIALOG_DATA);
	private func = inject(FuncService);

	public readonly form = new CommonForm<{ scheduleLink: string }>(inject(Injector));
	public saveBtn = viewChild.required<ElementRef<HTMLButtonElement>>('saveBtn');

	public header = 'Add Office Hours Link';

	ngOnInit() {
		if (this.dialogContext.data?.scheduleLink) {
			this.header = 'Edit Office Hours Link';
		}
	}


	ngAfterViewInit() {
		this.form.setSubmitButton(this.saveBtn(), async (values: { scheduleLink: string }, changed: string[]) => {

			if (changed.length === 0) return;

			const dialogContextData = this.dialogContext.data;
			if (!dialogContextData) return;

			await this.func.accelerator.updateFacilitatorScheduleLink({
				accId: dialogContextData.accId,
				facilitatorScheduleLink: values.scheduleLink
			});

			await this.dialogRef.close();
		});
	}



	//
	// Form Fields
	//
	readonly scheduleLink = computed<CommonUrlField>(() => ({
		config: signal<CommonUrlFieldConfig>({
			label: 'Office hours link',
			isRequired: false,
		}),
		formFieldName: 'scheduleLink',
		form: this.form,
		actualValue: computed(() => this.dialogContext.data?.scheduleLink ?? ''),
		pendingValue: signal<string | null>(null),
		saving: signal(false),
		error: signal(''),
	}));
}